// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1shYz","item":"PaymentsMobile_item__138qp","label":"PaymentsMobile_label__2wdGP","amount":"PaymentsMobile_amount__1lZ7F"};